import Select from 'components/form/Select';
import { useTranslation } from 'next-i18next';
import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';

interface Props extends React.ComponentPropsWithoutRef<typeof Select> {
  name: string;
  showLabel?: boolean;
}

const RHFSelect: React.FC<Props> = React.forwardRef<React.ElementRef<typeof Select>, Props>(
  props => {
    const { control } = useFormContext();
    const { t } = useTranslation();
    const { showLabel, label, required } = props;
    const {
      field: { value, onChange },
      fieldState: { error }
    } = useController({ name: props.name, control });

    const handleOnSelect = (value: string) => {
      onChange(value);
    };

    return (
      <div className="flex flex-col flex-1 basis-50">
        {showLabel && (
          <label
            className="text-neutral-900 dark:text-neutral-50 font-semibold mb-2"
            htmlFor={label}
          >{`${t(label)} ${required ? '*' : ''}`}</label>
        )}
        <Select
          error={!!error}
          helperText={error?.message}
          onChange={handleOnSelect}
          value={value}
          {...props}
        />
      </div>
    );
  }
);

RHFSelect.displayName = 'RHFSelect';

export default RHFSelect;
